import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ErrorTemplate } from './ErrorTemplate'

const STATUS_MESSAGES: Record<number, { title: string; description: string }> =
  {
    404: {
      title: 'Page not found',
      description:
        'The page you are looking for does not exist or has been moved.',
    },
    500: {
      title: 'Server error',
      description: 'An unexpected error occurred. Please try again later.',
    },
  }

export const RouteErrorFallback = () => {
  const error = useRouteError()

  if (import.meta.env.DEV) {
    console.error('Route error:', error)
  }

  if (isRouteErrorResponse(error)) {
    const known = STATUS_MESSAGES[error.status]
    return (
      <ErrorTemplate
        title={known?.title ?? `Error ${error.status}`}
        description={
          known?.description ?? 'An unexpected error occurred with this route.'
        }
        code={error.status}
      />
    )
  }

  const message = error instanceof Error ? error.message : String(error)

  return <ErrorTemplate title='Unexpected error' description={message} />
}
